import config from "config/config.js";
import getFreshToken from "api/xsrfToken.js";

const getcheckIn = () => {
  const xsrfToken = getFreshToken();
  const endpoint = `${config.baseUrl}/api/checkin`;
  const options = {
    method: "GET",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "https://www.foodiestrip.com",
      "Access-Control-Allow-Credentials": true,
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": xsrfToken
    },
    credentials: "include"
  };
  return fetch(endpoint, options)
    .then(response => {
      return response.json();
    })
    .then(response => {
      // eslint-disable-next-line no-console
      // console.log(response);
      return response;
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.log("errore", e);
    });
};

export default getcheckIn;
